<script setup lang="ts">
import { capitalize } from 'lodash-es'
import { computed } from 'vue'
import AllIcon from './Icons/AllIcon.vue'
import BraceletsIcon from './Icons/BraceletsIcon.vue'
import ChainsIcon from './Icons/ChainsIcon.vue'
import EarringsIcon from './Icons/EarringsIcon.vue'
import NecklacesIcon from './Icons/NecklacesIcon.vue'
import RingsIcon from './Icons/RingsIcon.vue'
import PendantsIcon from './Icons/PendantsIcon.vue'

const props = withDefaults(defineProps<{
    title: string,
    link: string,
    code: string,
    active?: boolean,
}>(), {
    active: false,
})

const iconComponent = computed(() => {
    switch (props.code) {
        case 'all':
            return AllIcon
        case 'bracelets':
            return BraceletsIcon
        case 'chains':
            return ChainsIcon
        case 'earrings':
            return EarringsIcon
        case 'necklaces':
            return NecklacesIcon
        case 'rings':
            return RingsIcon
        case 'pendants':
            return PendantsIcon
        default:
            return null
    }
})
</script>

<template>
    <div
        :class="['flex items-center px-3 py-1.5 rounded text-grayscale-900 text-p2 cursor-pointer', active ? 'bg-mint-50 text-mint-800 font-medium' : 'hover:bg-grayscale-50']"
        :href="link"
    >
        <component
            :is="iconComponent"
            class="w-4 h-4 mr-2"
        />
        <span class="truncate">{{ title }}</span>
    </div>
</template>
